export default function formatString(str, ...args) {
   return str.replace(/%s/g, () => args.shift() || "%s");
};